import type {CoreCoachInvitesSendParams} from '../../../../api/types/core/methods';
import type {PracticeInviteTarget} from '../../../../modules/invites/stores/types';
import type {SendInvitesResult} from './SendInvitesStrategy';
import type {SendInvitesParams} from './types';

import {inviteStore} from '../../../../api/invite';
import {logger} from '../../../../utils/logger';
import {SendInvitesStrategy} from './SendInvitesStrategy';

export class SendInvitesToPracticeStrategy extends SendInvitesStrategy {
  constructor(
    private readonly practiceInviteTarget: PracticeInviteTarget,
    private readonly params: SendInvitesParams,
  ) {
    super(params);
  }

  async sendInvites(): Promise<SendInvitesResult> {
    const params: CoreCoachInvitesSendParams = {
      ...this.params,
      recipients: this.mapInviteRecipientsToRequestRecipients(
        this.params.recipients ?? [],
      ),
    };

    logger.event('invite_send_type', {
      message_added: this.params.message ? 'yes' : 'no',
      send_copy: this.params.send_copy ? 'yes' : 'no',
      type: 'practice',
    });

    await inviteStore.send({
      b2b: {
        user_ids: [this.practiceInviteTarget._id],
        ...params,
      },
      core: params,
    });

    const recipientsCount = this.params.recipients?.length ?? 0;

    return {
      message: this.getDefaultSuccessMessage(),
      title: this.getDefaultSuccessTitle(recipientsCount),
    };
  }
}
